import { API_BASE } from './config';
import { getAccessToken } from './authStorage';

function authHeaders() {
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${getAccessToken()}`,
  };
}

async function handleRes(res) {
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(text || res.statusText);
  }
  return res.json();
}

/** List archived items with optional filters */
export function getArchivedItems({ entityType, search, from, to, page = 1, pageSize = 20 } = {}) {
  const params = new URLSearchParams({ page, pageSize });
  if (entityType) params.set('entityType', entityType);
  if (search)     params.set('search', search);
  if (from)       params.set('from', from);
  if (to)         params.set('to', to);
  return fetch(`${API_BASE}/api/archive?${params}`, { headers: authHeaders() }).then(handleRes);
}

/** Get single archived item detail */
export function getArchivedItem(id) {
  return fetch(`${API_BASE}/api/archive/${id}`, { headers: authHeaders() }).then(handleRes);
}

/** Archive any entity manually */
export function archiveEntity(entityType, entityId) {
  return fetch(`${API_BASE}/api/archive`, {
    method: 'POST',
    headers: authHeaders(),
    body: JSON.stringify({ entityType, entityId, source: 'manual' }),
  }).then(handleRes);
}

/** Restore (un-archive) an archived item by archive record id */
export function restoreArchivedItem(id) {
  return fetch(`${API_BASE}/api/archive/${id}`, {
    method: 'DELETE',
    headers: authHeaders(),
  }).then(handleRes);
}

/** Stats: count per entity type */
export function getArchiveStats() {
  return fetch(`${API_BASE}/api/archive/stats`, { headers: authHeaders() }).then(handleRes);
}
